export const T = {
  EYEBROW: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "10px",
    fontWeight: "600",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
  },
  DISPLAY: {
    fontFamily: "'Instrument Serif', 'DM Serif Display', Georgia, serif",
    fontSize: "26px",
    fontWeight: "500",
    //fontStyle: "italic",
    lineHeight: 1.2,
    letterSpacing: "0.02em",
  },
  BODY: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: 1.75,
    letterSpacing: "-0.01em",
  },
  DATA: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: 1.4,
    letterSpacing: "0.01em",
  },
  DATA_VALUE: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: 1.4,
    letterSpacing: "0.01em",
  },
  SUBHEADER: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: 1.3,
    letterSpacing: "0.01em",
  },
  WHISPER: {
    fontFamily: "'Instrument Serif', 'DM Serif Display', Georgia, serif",
    fontSize: "12px",
    fontWeight: "400",
    fontStyle: "italic",
    lineHeight: 1.5,
    letterSpacing: "0.03em",
  },
};
